export default __webpack_public_path__ + "static/media/river.5a7660e0.ogg";